import type { ReactNode } from 'react';

export const symbol_turn_slight_left: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M548.5-168.63Q540-177.25 540-190v-268L300-698v97q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-169q0-12.75 8.63-21.38Q257.25-800 270-800h169q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5h-97l240 240q8 8 13 18.96 5 10.95 5 23.04v268q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63Z"
		/>
	</svg>
);
